import { EStateStatus } from '@app/app.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ISystemParamState } from './system-params.reducers';

const _selectParam =
  createFeatureSelector<ISystemParamState>('systemParamsAdmin');
export const selectParam = createSelector(_selectParam, (param) => param);
export const selectParamInfo = createSelector(
  _selectParam,
  (param) => param?.param ?? null,
);
export const selectParamId = createSelector(
  _selectParam,
  (param) => param?.id ?? null,
);
export const selectParamSource = createSelector(
  _selectParam,
  (param) => param?.source ?? null,
);
export const selectParamHasChanges = createSelector(
  _selectParam,
  (param) => param?.hasChanges ?? false,
);
export const selectParamIsLoading = createSelector(
  _selectParam,
  (param) => param?.status === EStateStatus.LOADING,
);
